module.exports = __webpack_public_path__ + "static/media/drawings.08738fd5.svg";